import * as React from 'react';
export const billingQuoteSvg = React.forwardRef(function billingQuoteSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'm2.542 14.225-.042-.028V2a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v12.197l-.042.028-1.45-.87a2 2 0 0 0-1.924-.074L8 14.323 5.916 13.28a2 2 0 0 0-1.923.074l-1.45.87ZM1 2v12.465a1 1 0 0 0 .445.832l.792.527a.5.5 0 0 0 .534.013l1.994-1.196a.5.5 0 0 1 .48-.018l2.531 1.265a.5.5 0 0 0 .448 0l2.53-1.265a.5.5 0 0 1 .481.018l1.994 1.196a.5.5 0 0 0 .534-.012l.792-.528a1 1 0 0 0 .445-.832V2a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12.386 8.602a.75.75 0 0 1-.238 1.034l-1.114.696a2.75 2.75 0 0 1-2.54.195l-1.578-.676a1.25 1.25 0 0 0-1.155.09l-1.114.695a.75.75 0 1 1-.795-1.272l1.114-.696a2.75 2.75 0 0 1 2.54-.195l1.578.676a1.25 1.25 0 0 0 1.155-.09l1.113-.695a.75.75 0 0 1 1.034.238Zm0-3.999a.75.75 0 0 1-.238 1.033l-1.114.696a2.75 2.75 0 0 1-2.54.195l-1.578-.676a1.25 1.25 0 0 0-1.155.09l-1.114.695a.75.75 0 0 1-.795-1.272l1.114-.696a2.75 2.75 0 0 1 2.54-.195l1.578.676a1.25 1.25 0 0 0 1.155-.09l1.113-.695a.75.75 0 0 1 1.034.239Z',
    }),
  );
});
billingQuoteSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var billingQuote = {
  category: 'icon',
  colorable: true,
  name: 'billingQuote',
  svg: billingQuoteSvg,
};
